import { FormattedMessage } from 'react-intl';

import { FormattedCosts } from '@app/components/FormattedCosts';
import FormattedMoney from '@app/components/FormattedMoney';

import { alignEnd } from './OrderHistoryDetail.styles';
import { useOrderHistoryDetail } from './OrderHistoryDetailContext';
import messages from './TotalsRows.messages';

const TotalsRows = () => {
  const { itemsData, storeConfig, hasHardware } = useOrderHistoryDetail();
  const includingTax = storeConfig?.taxSalesDisplayPrice === 'including';

  return (
    <>
      {itemsData?.total?.subtotal.value ? (
        <tr>
          <th scope="row" colSpan={4}>
            <FormattedMessage {...messages.subtotal} />
          </th>
          <td css={alignEnd} data-testid="subtotal-value">
            {includingTax
              ? itemsData.total?.subtotalIncludingTax && (
                  <FormattedMoney {...itemsData.total?.subtotalIncludingTax} />
                )
              : itemsData.total?.subtotal && (
                  <FormattedMoney {...itemsData.total?.subtotal} />
                )}
          </td>
        </tr>
      ) : null}

      {itemsData?.total?.discounts?.map((discount) =>
        discount ? (
          <tr key={discount.label}>
            <th scope="row" colSpan={4}>
              <FormattedMessage {...messages.discount} />
            </th>
            <td css={alignEnd} data-testid="discount-value">
              <FormattedMoney
                currency={discount.amount.currency}
                value={(discount.amount.value || 0) * -1}
              />
            </td>
          </tr>
        ) : null,
      ) ?? null}

      {itemsData?.total?.taxes?.map((tax) =>
        tax ? (
          <tr key={tax.title}>
            <th scope="row" colSpan={4} data-testid="tax-type">
              {includingTax ? (
                tax && <FormattedMessage {...messages.inclTax} />
              ) : (
                <FormattedMessage {...messages.exTax} />
              )}{' '}
              ({tax.title})
            </th>
            <td css={alignEnd} data-testid="tax-amount">
              <FormattedMoney {...tax.amount} />
            </td>
          </tr>
        ) : null,
      ) ?? null}

      {hasHardware && itemsData?.total?.shippingHandling && (
        <tr>
          <th scope="row" colSpan={4}>
            <FormattedMessage {...messages.shippingHandling} />
          </th>
          <td css={alignEnd} data-testid="shipping-value">
            <FormattedCosts
              isShippingCost
              amount={
                itemsData?.total?.shippingHandling?.[
                  includingTax ? 'amountIncludingTax' : 'amountExcludingTax'
                ]
              }
            />
          </td>
        </tr>
      )}

      {itemsData?.total?.grandTotal.value ? (
        <tr>
          <th scope="row" colSpan={4}>
            <strong>
              <FormattedMessage {...messages.grandTotal} />
            </strong>
          </th>
          <td css={alignEnd} data-testid="total-value">
            <b>
              <FormattedMoney {...itemsData?.total.grandTotal} />
            </b>
          </td>
        </tr>
      ) : null}
    </>
  );
};

export default TotalsRows;
